import React, { useEffect, useState, Fragment, Button } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import Acciones from './Acciones';
import { useDispatch, useSelector } from 'react-redux'
import {EnviarRequisitosSeleccionados} from '../../../store/actions/encargado-cia-action'
const Requisitos = ({req, requi, setRequi, recargarRequisitos}) => {
    const [selected, setSelected]=useState([])
    const products=[{ rut:0, nombre:"cliente1", email:"cliente@gmail.com", patente:"3434", monedaIndemniza:"Pesos CLP", totalPagar:"3434",comuna:"Santiago", ciudad:"Santiago"},
  { rut:1, nombre:"cliente2", email:"cliente2@gmail.com", patente:"343433", monedaIndemniza:"Pesos CLP", totalPagar:"3434",comuna:"Santiago", ciudad:"Santiago"}
  ];
  const data_encargado_cia = useSelector((state) => state.encargado_compania)
  const {
    requisitosSeleccionados
  } = data_encargado_cia
  const [datosSiniestro, setDatosSiniestro] = useState({})
  const dispatch = useDispatch()   
  const columns=[ {
    dataField: 'nombre',
    text: `Valida Requisitos (Pendientes ${req && req.length - selected.length} )`,
    headerEvents: {
      onClick: (e, column, columnIndex) => recargar()
    },
    headerFormatter: (cell, row) => {
      return formatter();
    }
  }
];
const formatter = () => {
  return (
    <div>
      Valida Requisitos (Pendientes {req && req.length - selected.length}) 
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" style={{cursor:'pointer'}} viewBox="0 0 16 16">
          <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
          <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
      </svg>
    </div>
  )
}
const recargar = async () => {
  recargarRequisitos();
};
useEffect(()=>{
    if(req && req.length!==undefined){
      const opciones=req.filter(r=>(r.folioCarga>0 ))
      setSelected(opciones.map(r=>(r.id )))
      setRequi(opciones.map(r=>(r.id )))
    }
   
    dispatch(EnviarRequisitosSeleccionados([2,3,4]))
},[dispatch,req])
const selectRow = {
    mode: 'checkbox',       
    selected: selected,
    nonSelectable: [1,2, 3 ,4,5,6,7,8,9,10,11,12,13,14,15,16],
   
    hideSelectAll: true
    
  };
 const handleOnSelect = (row, isSelect,rowIndex,e) => {
    
    if (isSelect) {
      setSelected( [...selected, row.id] );
      setRequi(...requi, row.id )
    } else {
        setSelected(selected.filter(x => x !== row.id) );
        setRequi(requi.filter(x => x !== row.id) );
    }
  }
 
  return (
    <>
      <div>

          {
            req && (
              <BootstrapTable
              keyField="id"
              data={  req }
              columns={ columns }
              selectRow={ selectRow }
             
              />
            )
        }

      </div>
  
      </>
  )
}

export default Requisitos